import { useMutation } from '@apollo/client';
import { CREATE_DOCUMENT } from '../../graphql/mutations';

interface CreateDocumentResponse {
  uuid: string;
}

interface CreateDocumentData {
  createDocument: CreateDocumentResponse;
}

interface CreateDocumentVars {
  document: {
    studyId?: string;
    patientId: string;
    typeId: string;
    carePlanId?: string;
    careActivityId?: string;
    status: string;
    name?: string;
    base64File?: string;
    fileType?: string;
  };
}

export const useCreateDocument = (): {
  createDocument: (variables: CreateDocumentVars) => Promise<{ data?: CreateDocumentData }>;
  loading: boolean;
  error?: any;
} => {
  const [createDocumentMutation, { loading, error }] = useMutation<
    CreateDocumentData,
    CreateDocumentVars
  >(CREATE_DOCUMENT);

  const createDocument = (variables: CreateDocumentVars) => createDocumentMutation({ variables });

  return {
    createDocument,
    loading,
    error,
  };
};
